import React from "react";
import PropTypes from "prop-types";
import ReactModal from "react-modal";
import MaterialIcon from "material-icons-react";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
};

const SimpleModal = ({
  isOpen,
  onConfirm,
  onCancel,
  icon = "",
  headline = "",
  message = "",
  confirmLabel,
  cancelLabel = "",
  containerClassName,
  children,
  buttonsReverseOrder,
}) => (
  <ReactModal
    isOpen={isOpen}
    onRequestClose={onCancel || onConfirm}
    style={customStyles}
    shouldCloseOnOverlayClick={false}
    ariaHideApp={false}
    contentLabel="Modal"
  >
    <div
      className={
        containerClassName
          ? `modal-container ${containerClassName}`
          : "modal-container"
      }
    >
      {icon && (
        <span className="in-active-color">
          <MaterialIcon size="large" icon={icon} />
        </span>
      )}
      {headline && <h4 className="text-center mt-2">{headline}</h4>}
      <p dangerouslySetInnerHTML={{ __html: message }} />

      {children}

      <div className="buttons-container w-100">
        {buttonsReverseOrder
          ? [
              <button
                className="btn btn-outline w-25"
                onClick={onConfirm}
                key="btn-reverse-1"
              >
                {confirmLabel}
              </button>,
              onCancel && (
                <button
                  className="btn btn-action w-25"
                  onClick={onCancel}
                  key="btn-reverse-2"
                >
                  {cancelLabel}
                </button>
              ),
            ]
          : [
              onCancel && (
                <button
                  className="btn btn-outline w-25"
                  onClick={onCancel}
                  key="btn-1"
                >
                  {cancelLabel}
                </button>
              ),
              <button
                className="btn btn-action w-25"
                onClick={onConfirm}
                key="btn-2"
              >
                {confirmLabel}
              </button>,
            ]}
      </div>
    </div>
  </ReactModal>
);

export default SimpleModal;

SimpleModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  icon: PropTypes.string,
  headline: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  message: PropTypes.string,
  confirmLabel: PropTypes.string.isRequired,
  cancelLabel: PropTypes.string,
  containerClassName: PropTypes.string,
  children: PropTypes.node,
  buttonsReverseOrder: PropTypes.bool,
};
